import { useCallback, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';

// Authenticated fetch against /api/maison/conga/*; the token stays in a ref so callbacks are stable.
export const useMaisonApi = () => {
    const { token } = useAuth();
    const tokenRef = useRef(token);
    useEffect(() => { tokenRef.current = token; }, [token]);

    return useCallback((path, method = 'GET', body = null) => fetch(`/api/maison/conga${path}`, {
        method,
        headers: {
            Authorization: `Bearer ${tokenRef.current}`,
            ...(body !== null ? { 'Content-Type': 'application/json' } : {}),
        },
        body: body !== null ? JSON.stringify(body) : undefined,
    }), []);
};
